const styles = {
  image: {
    transition: 'opacity 300ms ease-in-out',
    opacity: 1,
    width: '100%'
  },
  hidden: {
    visibility: 'hidden',
    opacity: 0
  },
  desc: {
    fontSize: '18px',
    lineHeight: '22px'
  }
}

export default styles
